import Icon from '@mdi/react'

import { Flex } from '@/components/ui/flex'
import { ProgressCircleRing, ProgressCircleRoot } from '@/components/ui/progress-circle'
import { Tooltip } from '@/components/ui/tooltip'
import { Text } from '@/components/ui/typography'
import useColorModeValue from '@/hooks/useColorModeValue'
import { IApproval, TServiceNowChangesStates } from '@/types/tasksApprovals'
import { getServiceNowChangeReqIcon, isSailPointCert, isServiceNowChangeRequests } from '@/utils/approvals'

const Status = ({ item }: { item: IApproval }) => {
    const textColor = useColorModeValue('rgba(84, 79, 64, 0.7)', 'rgba(255, 255, 255, 0.7)')
    const progressColor = useColorModeValue('var(--chakra-colors-dark-700)', '#f0f0ee')
    const progressTrackColor = useColorModeValue('#f0f0ee', 'var(--chakra-colors-dark-700)')

    const getCompletedPercentage = () => {
        if (!item.metadata) return 0
        if (!item.metadata.counter) return 0

        const completed = parseInt(item.metadata.counter.split('/')[0])
        const total = parseInt(item.metadata.counter.split('/')[1])

        return (completed / total) * 100
    }

    const getServiceNowChangeReqStatus = () => {
        return (
            <Flex pb="0" alignItems="center">
                <Tooltip content={item?.metadata?.state as TServiceNowChangesStates}>
                    <Icon path={getServiceNowChangeReqIcon(item)} size="16px" />
                </Tooltip>
                <Text color={textColor} fontSize="14px" lineHeight="20px" pl="8px">
                    {item.description}
                </Text>
            </Flex>
        )
    }
    return (
        <Flex
            alignItems="center"
            pr={['0', '0', '12px']}
            pb={['0', '0', '0']}
            pl={['0', '0', '0']}
            pt="4px"
            flexDir="row"
            w={['100%', '100%', 'auto']}
        >
            {isSailPointCert(item) && (
                <Flex>
                    <ProgressCircleRoot value={getCompletedPercentage()} size="xs" color={progressColor}>
                        <ProgressCircleRing trackColor={progressTrackColor} css={{ '--thickness': '2px' }} />
                    </ProgressCircleRoot>
                    <Text pl="8px" fontSize="14px" lineHeight="20px" color={textColor} textAlign={['left', 'left', 'right']}>
                        Completed {item.metadata?.counter?.replace('/', ' / ')}
                    </Text>
                </Flex>
            )}
            {isServiceNowChangeRequests(item) && getServiceNowChangeReqStatus()}
        </Flex>
    )
}

export default Status
